import { useEffect } from "react";

import { AUTH_ROUTE_PATHS } from "@jti/fe-common/routes/auth-routes";
import { useUser } from "@jti/ui/hooks/useUser";
import { useAuthHrefResolver } from "@jti/ui/providers/AuthRoutingProvider";

export const useRedirectOnTradeIn = (isTradeIn?: boolean) => {
  const resolveAuthHref = useAuthHrefResolver();
  const { isUserLoggedIn, isCheckingUser } = useUser();

  useEffect(() => {
    if (isCheckingUser) return;

    if (isTradeIn && isUserLoggedIn === false) {
      window.location.replace(
        resolveAuthHref({
          route: AUTH_ROUTE_PATHS.login,
          search: { returnUrl: window.location.pathname },
        })
      );
    }
  }, [isUserLoggedIn, isCheckingUser, isTradeIn, resolveAuthHref]);
};
